var InputErrorPositions = /*#__PURE__*/ function(InputErrorPositions) {
    InputErrorPositions["Bottom"] = "bottom";
    InputErrorPositions["Top"] = "top";
    return InputErrorPositions;
}({});
var InputLabelPositions = /*#__PURE__*/ function(InputLabelPositions) {
    InputLabelPositions["Left"] = "left";
    InputLabelPositions["Right"] = "right";
    InputLabelPositions["Top"] = "top";
    return InputLabelPositions;
}({});
var InputLooks = /*#__PURE__*/ function(InputLooks) {
    InputLooks["Default"] = "default";
    return InputLooks;
}({});

export { InputErrorPositions, InputLabelPositions, InputLooks };
//# sourceMappingURL=input.js.map
